<template>
    <VirtualAccountContainer>
        <Title>사용중계좌</Title>
        <AccountUseTable>
            <thead>
                <tr>
                    <Th>고객명</Th>
                    <Th>연락처</Th>
                    <Th>가상계좌번호</Th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in details" :key="index">
                    <Td :style="{ filter: isTestUserItem(item) ? 'blur(3px)' : 'none' }">{{ item.CUSNM }}</Td>
                    <Td :style="{ filter: isTestUserItem(item) ? 'blur(3px)' : 'none' }">{{ item.MOBILENO }}</Td>
                    <Td :style="{ filter: isTestUserItem(item) ? 'blur(3px)' : 'none' }">{{ item.acc }}</Td>
                </tr>
            </tbody>
        </AccountUseTable>

        <ButtonGroup>
            <SubmitButton @click="closeModal">닫기</SubmitButton>
        </ButtonGroup>
    </VirtualAccountContainer>
</template>

<script>
import * as AccountUseModalCss from '@/assets/styles/account/AccountUseModalCss.js';

const noScrollStyle = {
    overflow: 'hidden',
    paddingRight: '15px'
};

export default {
    name: 'AccountUseModal',

    components: {
        ...AccountUseModalCss,
    },

    props: {
        details: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            originalStyles: null,
        };
    },


    methods: {
        closeModal() {
            this.$emit('closeModal');
        },

        disableScroll() {
            this.originalStyles = {
                overflow: document.body.style.overflow,
                paddingRight: document.body.style.paddingRight
            };
            Object.assign(document.body.style, noScrollStyle);
        },

        enableScroll() {
            if (this.originalStyles) {
                document.body.style.overflow = this.originalStyles.overflow;
                document.body.style.paddingRight = this.originalStyles.paddingRight;
                this.originalStyles = null;
            }
        },

        isTestUserItem(item) {
            return item && item.CUSNM === '테스트';
        }
    },

    mounted() {
        this.disableScroll();
    },

    beforeUnmount() {
        this.enableScroll();
    }
};
</script>